// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"EditBirthDate_errorMessage__2u2Pa"};